<template>
    <div id="loading">
        <div id="loader">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="margin: auto; background: none; shape-rendering: auto;"
                width="24px"
                height="24px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
            >
                <rect x="5.5" y="5.5" width="25" height="25" fill="#00b8d3">
                    <animate
                        attributeName="fill"
                        values="#ffffff;#00b8d3;#00b8d3"
                        keyTimes="0;0.125;1"
                        dur="1s"
                        repeatCount="indefinite"
                        begin="0s"
                        calcMode="discrete"
                    ></animate>
                </rect>
                <rect x="37.5" y="5.5" width="25" height="25" fill="#00b8d3">
                    <animate
                        attributeName="fill"
                        values="#ffffff;#00b8d3;#00b8d3"
                        keyTimes="0;0.125;1"
                        dur="1s"
                        repeatCount="indefinite"
                        begin="0.125s"
                        calcMode="discrete"
                    ></animate>
                </rect>
                <rect x="69.5" y="5.5" width="25" height="25" fill="#00b8d3">
                    <animate
                        attributeName="fill"
                        values="#ffffff;#00b8d3;#00b8d3"
                        keyTimes="0;0.125;1"
                        dur="1s"
                        repeatCount="indefinite"
                        begin="0.25s"
                        calcMode="discrete"
                    ></animate>
                </rect>
                <rect x="5.5" y="37.5" width="25" height="25" fill="#00b8d3">
                    <animate
                        attributeName="fill"
                        values="#ffffff;#00b8d3;#00b8d3"
                        keyTimes="0;0.125;1"
                        dur="1s"
                        repeatCount="indefinite"
                        begin="0.875s"
                        calcMode="discrete"
                    ></animate>
                </rect>
                <rect x="69.5" y="37.5" width="25" height="25" fill="#00b8d3">
                    <animate
                        attributeName="fill"
                        values="#ffffff;#00b8d3;#00b8d3"
                        keyTimes="0;0.125;1"
                        dur="1s"
                        repeatCount="indefinite"
                        begin="0.375s"
                        calcMode="discrete"
                    ></animate>
                </rect>
                <rect x="5.5" y="69.5" width="25" height="25" fill="#00b8d3">
                    <animate
                        attributeName="fill"
                        values="#ffffff;#00b8d3;#00b8d3"
                        keyTimes="0;0.125;1"
                        dur="1s"
                        repeatCount="indefinite"
                        begin="0.75s"
                        calcMode="discrete"
                    ></animate>
                </rect>
                <rect x="37.5" y="69.5" width="25" height="25" fill="#00b8d3">
                    <animate
                        attributeName="fill"
                        values="#ffffff;#00b8d3;#00b8d3"
                        keyTimes="0;0.125;1"
                        dur="1s"
                        repeatCount="indefinite"
                        begin="0.625s"
                        calcMode="discrete"
                    ></animate>
                </rect>
                <rect x="69.5" y="69.5" width="25" height="25" fill="#00b8d3">
                    <animate
                        attributeName="fill"
                        values="#ffffff;#00b8d3;#00b8d3"
                        keyTimes="0;0.125;1"
                        dur="1s"
                        repeatCount="indefinite"
                        begin="0.5s"
                        calcMode="discrete"
                    ></animate>
                </rect>
            </svg>
            <div>
                {{ $t("Loading...") }}
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
#loading {
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    height: 100%;
    flex-direction: column;
    display: flex;
    z-index: 100;
    justify-content: center;
    align-items: center;
    align-content: center;
    color: white;
}
svg {
    width: 24px;
    height: 24px;
}
</style>
